import { render, staticRenderFns } from "./PrimaryNav.vue?vue&type=template&id=a5a74368&scoped=true&"
import script from "./PrimaryNav.vue?vue&type=script&lang=js&"
export * from "./PrimaryNav.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryNav.vue?vue&type=style&index=0&id=a5a74368&lang=scss&scoped=true&"
import style1 from "./PrimaryNav.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a74368",
  null
  
)

export default component.exports